import { Node, mergeAttributes } from '@tiptap/core';

const linkBlockStyles = 'font-family: Amiri, serif; font-size: 18px; color: #C5A059; background-color: rgba(197, 160, 89, 0.08); border: 1px solid rgba(197, 160, 89, 0.25); padding: 0.75rem 1.25rem; border-radius: 9999px; display: inline-flex; align-items: center; gap: 0.5rem; cursor: pointer; transition: all 0.3s;';

/**
 * Standalone link block - renders as a styled link (old creator-studio behavior).
 * In editor: uses span to prevent navigation on click (select for edit instead).
 * Serializes to type: 'link', value: JSON.stringify({ url, text })
 */
export const LinkBlock = Node.create({
  name: 'linkBlock',

  group: 'block',

  atom: true,

  addAttributes() {
    return {
      href: { default: null },
      text: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-link-block]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    const href = node.attrs.href || '#';
    const text = node.attrs.text || href;
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-link-block': '',
        class: 'dawaer-link-block my-6 text-center',
      }),
      [
        'a',
        {
          href,
          target: '_blank',
          rel: 'noopener noreferrer',
          class: 'inline-flex items-center gap-2 px-5 py-3 rounded-full transition-all duration-300 hover:shadow-md',
          style: 'font-family: Amiri, serif; font-size: 18px; color: #C5A059; background-color: rgba(197, 160, 89, 0.08); border: 1px solid rgba(197, 160, 89, 0.25);',
        },
        text,
      ],
    ];
  },

  addNodeView() {
    return ({ node, getPos, editor }) => {
      const dom = document.createElement('div');
      dom.className = 'dawaer-link-block my-6 text-center';

      const span = document.createElement('span');
      span.className = 'dawaer-link-block-preview inline-flex items-center gap-2 px-5 py-3 rounded-full transition-all duration-300 hover:shadow-md';
      span.style.cssText = linkBlockStyles;
      span.textContent = node.attrs.text || node.attrs.href || '';
      span.setAttribute('role', 'button');
      span.setAttribute('tabindex', '0');

      span.addEventListener('click', (e) => {
        if (e.metaKey || e.ctrlKey) {
          const href = node.attrs.href;
          if (href) window.open(href, '_blank', 'noopener,noreferrer');
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        const pos = getPos();
        if (pos !== undefined) {
          editor.commands.setNodeSelection(pos);
        }
      });

      span.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const pos = getPos();
          if (pos !== undefined) {
            editor.commands.setNodeSelection(pos);
          }
        }
      });

      dom.appendChild(span);

      return {
        dom,
        update: (updatedNode) => {
          if (updatedNode.type !== node.type) return false;
          span.textContent = updatedNode.attrs.text || updatedNode.attrs.href || '';
          return true;
        },
      };
    };
  },
});
